import { useTranslation } from "@opendash/i18n";
import { Select } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { KanbanGrouping } from "..";

type Props = {
  value?: KanbanGrouping;
  onChange?: (value: KanbanGrouping) => void;
};

export const ViewSelect = observer((props: Props) => {
  const t = useTranslation();

  const options = [
    { value: "state", label: t("maintenance:monitor.view.state.label") },
    { value: "user", label: t("maintenance:monitor.view.user.label") },
    { value: "role", label: t("maintenance:monitor.view.role.label") },
    { value: "project", label: t("maintenance:monitor.view.project.label") },
  ];

  return (
    <Select
      options={options}
      value={props.value}
      onChange={(value: KanbanGrouping) => props.onChange?.(value)}
      style={{ width: 120 }}
    />
  );
});
